import { Base_Url } from "../../Base Url/BaseUrl";
import { postApiWithAuthenticated, getListWithAuthenticated} from "../../Api Method/ApiMethod";


const MasterBlogBaseUrl = `${Base_Url}/blog`;


export const blogList = async (params) => {
  let url = `${MasterBlogBaseUrl}/blogList`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};
export const blogListForWebsite = async (params) => {
  let url = `${MasterBlogBaseUrl}/blogListForWebsite`;

  const res = await postApiWithAuthenticated(url, params);
  return res;
};

export const addUpdateBlog = async (url = '', params) => {
    
  
    const res = await postApiWithAuthenticated(`${MasterBlogBaseUrl}${url}`, params);
    return res;
  };
// export const AddUpdateStateApi = async (url = '', params) => {
//   if (params.stateID === null || params.stateID === undefined) {
//     delete params.stateID;
//   }

//   const res = await postApiWithAuthenticated(`${MasterBlogBaseUrl}${url}`, params);
//   return res;
// };

export const ChangeStateStatus = async (id) => {
  let url = `${MasterBlogBaseUrl}/ChangeBlogStatus?blogKeyID=${id}`;
  const res = await getListWithAuthenticated(url);
  return res;
};


export const GetBlogModal = async (id) => {
    let url = `${MasterBlogBaseUrl}/getBlog?blogKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };
export const getBlogForWebsite = async (id) => {
    let url = `${MasterBlogBaseUrl}/getBlogForWebsite?blogKeyID=${id}`;
  
    const res = await getListWithAuthenticated(url);
    return res;
  };


// export const GetStateLookupList = async () => {
//     const url = `${MasterBlogBaseUrl}/GetStateLookupList`;
  
//     const res = await getListWithAuthenticated(url );
//     return res;
//   };
  
//   export const ChangeStateStatus = async (id,UserKeyID) => {
//     let url = `${MasterBlogBaseUrl}/ChangeStateStatus?StateID=${id}&UserKeyID=${UserKeyID}`;
//     const res = await getListWithAuthenticated(url);
//     return res;
//   };